import React, { useEffect, useState } from "react";
import { Chart } from "react-google-charts";



const EquipmentListChart = ({ data }) => {
  // Calculate total and percentages
  const amcActive = data?.amcActive || 0;
  const amcExpired = data?.amcExpired || 0;
  const nonAmc = data?.nonAmc || 0;
  const total = amcActive + amcExpired + nonAmc;
  
  const amcActivePercent = total > 0 ? ((amcActive / total) * 100).toFixed(1) : 0;
  const amcExpiredPercent = total > 0 ? ((amcExpired / total) * 100).toFixed(1) : 0;
  const nonAmcPercent = total > 0 ? ((nonAmc / total) * 100).toFixed(1) : 0;

  // Convert your params-style data into chart format
  const chartData = [
    ["Category", "Count"],
    ["AMC Active", amcActive],
    ["AMC Expired", amcExpired],
    ["Non-AMC", nonAmc],
  ];
  const [offset, setOffset] = useState(0.02);

  const isEmpty = !data?.amcActive && !data?.amcExpired && !data?.nonAmc;

  useEffect(() => {
    const interval = setInterval(() => {
      setOffset((prev) => (prev === 0.02 ? 0.06 : 0.02));
    }, 1500); // smooth loop

    return () => clearInterval(interval);
  }, []);

  function getValue(type, data) {
    let value = 0;

    switch (type) {
      case "AMC Active":
        value = data?.amcActive || 0;
        break;
      case "AMC Expired":
        value = data?.amcExpired || 0;
        break;
      case "Non-AMC":
        value = data?.nonAmc || 0;
        break;
      default:
        value = 0;
    }

    return value;
  }

const options = {
  pieHole: 0.55, // more modern donut
      1: { offset: 0.05 }, 

  colors: ["#00b894", "#ff7675", "#fdcb6e"],

  backgroundColor: "transparent",

  legend: {
    position: "bottom",
    alignment: "center",
    textStyle: {
      fontSize: 11,
      color: "#2d3436",
      bold: true,
    },
  },

  chartArea: {
    width: "88%",
    height: "78%",
  },

  pieSliceText: "percentage",

  pieSliceBorderColor: "#ffffff",

slices: {
      0: { offset: offset / 0 },
      1: { offset: offset / 0.9 },
      2: { offset: offset / 0 },
    },

  tooltip: {
    text: "both",
    showColorCode: true,
  },

  animation: {
    startup: true,
    duration: 1200,
    easing: "out",
  },

  is3D: true,
  fontName: "lato",
  pieSliceTextStyle: {
    color: "#ffffff",
    fontSize: 12,
  },
};

  return (
    <div style={styles.card}>
      <div style={styles.header}>⚙️ Equipments</div>

      <div style={styles.chartWrapper}>
        {isEmpty ? (
          <div style={styles.emptyState}>
            <div style={{ fontSize: '40px', marginBottom: '10px' }}>🔧</div>
            No Data Available
          </div>
        ) : (
          <Chart
            chartType="PieChart"
            data={chartData}
            options={options}
            width="100%"
            height="300px"
          />
        )}
      </div>
    </div>
  );
};

export default EquipmentListChart;

// 🎨 Styles
const styles = {
  card: {
    background: "#fff",
    padding: "10px",
    borderRadius: "16px",
    boxShadow: "0 10px 25px rgba(0,0,0,0.08)",
  },

 header: {
    fontSize: "15px",
    fontWeight: "600",
    color: "#2d3436",
    marginBottom: "10px",
  },
  chartWrapper: {
    minHeight: "300px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  emptyState: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    color: "#b2bec3",
    fontSize: "14px",
    fontWeight: "500",
    textAlign: "center",
  },
  footer: {
    display: "flex",
    justifyContent: "space-around",
    fontSize: "13px",
    fontWeight: "500",
  },
};